import gql from 'graphql-tag';
import { echoLightPostFragment } from './echo-light-post.fragment';

export const echoContentFragment = gql`
  fragment echoContentFragment on EchoContent {
    originalPost {
      ...echoLightPostFragment
    }
  }
  ${echoLightPostFragment}
`;
